import { useId } from "react";
import { presets, type Range } from "@/lib/dates";

interface Props {
  value: Range;
  onChange: (range: Range, presetId: string | null) => void;
  presetId: string | null;
}

export default function DateRangePicker({ value, onChange, presetId }: Props) {
  const fromId = useId();
  const toId = useId();

  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="flex flex-wrap gap-1.5">
        {presets.map((p) => {
          const active = presetId === p.id;
          return (
            <button
              key={p.id}
              type="button"
              onClick={() => onChange(p.range(), p.id)}
              className={`rounded-md border px-2.5 py-1 text-xs font-medium transition ${
                active
                  ? "border-ink-900 bg-ink-900 text-white"
                  : "border-ink-200 bg-white text-ink-600 hover:border-ink-300"
              }`}
            >
              {p.label}
            </button>
          );
        })}
      </div>
      <div className="flex items-center gap-2 text-xs text-ink-500">
        <label htmlFor={fromId} className="sr-only">From</label>
        <input
          id={fromId}
          type="date"
          value={value.from}
          onChange={(e) => onChange({ ...value, from: e.target.value }, null)}
          className="rounded-md border border-ink-200 px-2 py-1"
        />
        <span>→</span>
        <label htmlFor={toId} className="sr-only">To</label>
        <input
          id={toId}
          type="date"
          value={value.to}
          onChange={(e) => onChange({ ...value, to: e.target.value }, null)}
          className="rounded-md border border-ink-200 px-2 py-1"
        />
      </div>
    </div>
  );
}
